import { Tooltip } from "antd";
import dayjs from "dayjs";
import _ from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import BigPencilIcon from "@/Components/Icons/BigPencilIcon";
import DeleteIcon from "@/Components/Icons/DeleteIcon";
import { ACTION_BTN_HOVER_CLR } from "@/Constants/common";
import {
  getDayWiseRates,
  removeDayFromJobShiftObj,
  toggleMultipleShiftEditing,
  updateActiveStep,
  updateFirstMultipleSelectedJobShiftObj,
  updateJobData,
  updateSelectedJobShiftObj,
  updateToggleSelected,
} from "@/reducers/clientcreatejob";
import { TOOLTIPTEXT, createJobValidations } from "@/utilities/CommonText";
import { showErrorToast } from "@/utilities/utils";

import ActionIcons from "../ActionIcons";

/**
 * Function to render the JobShiftListsActions component.
 *
 * @return {JSX.Element} The React component to be rendered
 */
const JobShiftListsActions = () => {
  const {
    selectedJobShiftObj,
    enableMultipleShiftEditing,
    jobShiftObj,
    jobData,
    firstMultipleSelectedJobShiftObj,
  } = useSelector((state) => state.clientCreateJob);
  const dispatch = useDispatch();
  return (
    <div className="Actions_Wrapper">
      <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
        {_.isEmpty(firstMultipleSelectedJobShiftObj) ? (
          <>
            {jobData.startDate &&
            jobData.endDate &&
            jobData.startTime &&
            jobData.endTime ? (
              <Tooltip title={TOOLTIPTEXT.edit}>
                <div
                  className={`group ${ACTION_BTN_HOVER_CLR.lightBlue}`}
                  onClick={() => {
                    if (
                      jobData.startDate &&
                      jobData.endDate &&
                      jobData.startTime &&
                      jobData.endTime
                    ) {
                      if (selectedJobShiftObj.length > 0) {
                        let firstObj = jobShiftObj.find(
                          (shift) =>
                            shift.date === _.sortBy(selectedJobShiftObj)[0],
                        );
                        dispatch(
                          updateFirstMultipleSelectedJobShiftObj(firstObj),
                        );
                        dispatch(toggleMultipleShiftEditing(true));
                      } else {
                        showErrorToast(createJobValidations.selectJobShift);
                      }
                    } else {
                      showErrorToast(createJobValidations.selectAllFields);
                    }
                  }}
                >
                  <BigPencilIcon cls="group-hover:text-primary" />
                </div>
              </Tooltip>
            ) : null}

            <Tooltip title={TOOLTIPTEXT.delete}>
              <div
                className={`group ${ACTION_BTN_HOVER_CLR.red}`}
                onClick={() => {
                  if (selectedJobShiftObj.length > 0) {
                    let curDates = jobShiftObj.map((shift) => shift.date);
                    curDates = curDates.filter(
                      (date) => !selectedJobShiftObj.includes(date),
                    );
                    selectedJobShiftObj.forEach((date) => {
                      dispatch(
                        removeDayFromJobShiftObj({
                          removeBy: "date",
                          value: date,
                        }),
                      );
                    });
                    showErrorToast(createJobValidations.shiftDeleted, {
                      id: "no_job_shift_selected",
                    });
                    dispatch(updateSelectedJobShiftObj([]));
                    dispatch(updateToggleSelected());
                    let newJobRanges = jobData.selectDatesRanges.filter(
                      (range) => {
                        return !selectedJobShiftObj.includes(range[0]);
                      },
                    );
                    setTimeout(() => {
                      dispatch(
                        updateJobData({
                          startDate: curDates.length ? curDates[0] : null,
                          endDate: curDates.length
                            ? curDates[curDates.length - 1]
                            : null,
                          selectDatesRanges: newJobRanges.length
                            ? newJobRanges
                            : [],
                          selectDateJobDates: curDates.length ? curDates : [],
                          callback: () => {
                            if (curDates.length === 0) {
                              dispatch(updateActiveStep(2));
                            }
                          }, // callback to update the active step after deleting the job shift
                        }),
                      );
                    }, 100);
                  } else {
                    showErrorToast(createJobValidations.selectJobShift);
                  }
                }}
              >
                <DeleteIcon cls="group-hover:text-red" />
              </div>
            </Tooltip>
          </>
        ) : null}
        {enableMultipleShiftEditing ? (
          <>
            <Tooltip title={TOOLTIPTEXT.update}>
              <div
                className={`group ${ACTION_BTN_HOVER_CLR.green}`}
                onClick={() => {
                  let firstActiveDateObj = jobShiftObj.find(
                    (shift) =>
                      shift.date === firstMultipleSelectedJobShiftObj.date,
                  );
                  if (
                    jobData.startDate &&
                    jobData.endDate &&
                    jobData.startTime &&
                    jobData.endTime &&
                    [jobData.rateCardList].length > 0
                  ) {
                    let dayObj = {};
                    selectedJobShiftObj.forEach((date) => {
                      let day = dayjs(date, "DD-MM-YYYY").format("dddd");
                      if (dayObj[day]) {
                        dayObj[day].push(date);
                      } else {
                        dayObj[day] = [date];
                      }
                    });
                    Object.keys(dayObj).forEach((day) => {
                      dispatch(
                        getDayWiseRates({
                          fromEditing: true,
                          day,
                          selected_date: dayObj[day],
                          _startTime: firstActiveDateObj.startTime,
                          _endTime: firstActiveDateObj.endTime,
                          _breakTime: firstActiveDateObj.break,
                          _adminTime: firstActiveDateObj.admin,
                        }),
                      );
                    });
                    // selectedJobShiftObj.forEach((date) => {
                    //   dispatch(
                    //     getDayWiseRates({
                    //       fromEditing: true,
                    //       day: dayjs(date, "DD-MM-YYYY").format("dddd"),
                    //       _currentDate: date,
                    //       _startTime: firstActiveDateObj.startTime,
                    //       _endTime: firstActiveDateObj.endTime,
                    //       _breakTime: firstActiveDateObj.break,
                    //       _adminTime: firstActiveDateObj.admin,
                    //     }),
                    //   );
                    // });
                  }
                  dispatch(updateFirstMultipleSelectedJobShiftObj({}));
                  dispatch(toggleMultipleShiftEditing(false));
                  dispatch(updateToggleSelected());
                  dispatch(updateSelectedJobShiftObj([]));
                }}
              >
                <ActionIcons type={"approve"} />
              </div>
            </Tooltip>
            <Tooltip title={TOOLTIPTEXT.discard}>
              <div
                className={`group ${ACTION_BTN_HOVER_CLR.red}`}
                onClick={() => {
                  setTimeout(() => {
                    if (
                      jobData.startDate &&
                      jobData.endDate &&
                      jobData.startTime &&
                      jobData.endTime &&
                      [jobData.rateCardList].length > 0
                    ) {
                      dispatch(
                        getDayWiseRates({
                          fromEditing: true,
                          day: dayjs(
                            firstMultipleSelectedJobShiftObj.date,
                            "DD-MM-YYYY",
                          ).format("dddd"),
                          selected_date: [
                            firstMultipleSelectedJobShiftObj.date,
                          ],
                          _startTime:
                            firstMultipleSelectedJobShiftObj.startTime,
                          _endTime: firstMultipleSelectedJobShiftObj.endTime,
                          _breakTime: firstMultipleSelectedJobShiftObj.break,
                          _adminTime: firstMultipleSelectedJobShiftObj.admin,
                        }),
                      );
                    }
                    dispatch(updateFirstMultipleSelectedJobShiftObj({}));
                    dispatch(toggleMultipleShiftEditing(false));
                  }, 200);
                }}
              >
                <ActionIcons type={"reject"} />
              </div>
            </Tooltip>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default JobShiftListsActions;
